export const SLOTS = {
    branding: 5752,
    'branding-video': 803510,
    'branding-gof': 1189408,
    // content: 1400449, // ya: R-A-17421134-2
    // 'content-2': 1400467, // ya: R-A-17421134-1
    top: 85857,
    bottom: 87779,
    aside: 331953,
    // 'aside-vkp': 757827, // ya: R-A-17421134-9
    fullscreen: 692161,
    'mobile-top': 692162, // ya: R-A-17421134-5 скрыт в рамках ALLIANCE-68174
    // 'mobile-content': 1400472, // ya: R-A-17421134-4
    // 'mobile-content-2': 1400517, // ya: R-A-17421134-3
    // 'mobile-bottom': 692163, // ya: R-A-17421134-6
    'mobile-fullscreen': 692164,
};

export const DEFAULT_CONTEXT = {
    slots: SLOTS,
    addBannersDisableCondition: () => undefined,
    removeBannersDisableCondition: () => undefined,
    checkBannersAvailability: () => true,
};

export const SITEZONE = 5;

export const SEARCH_PARAMS_WITH_NO_BANNERS = [
    'fromSA',
    'from=newsapp',
    'from=special',
    'mt_link_id=jsc1s8', // from RuStore
];
